module.exports = "img {\n  max-width: 100%; }\n"